<template>
  <div class="page-main">
    <!-- 表格操作条 -->
    <vxe-toolbar ref="refToolbar" size="mini" import export print custom :loading="loading">
      <template #buttons>
        <el-button type="success" size="mini" icon="el-icon-plus" @click="itemAdd"
          >新增客户
        </el-button>
        <el-button
          v-if="$tool.hasControl(['/customers/deleteBatchVue'])"
          type="danger"
          size="mini"
          @click="batchDelete"
          >删除客户</el-button
        >
        <el-button
          v-if="$tool.hasControl(['/customers/customerNameBatchVue'])"
          type="primary"
          size="mini"
          @click="batchReplaceSalesMan"
        >
          批量替换业务员
        </el-button>
        <el-button
          v-if="$tool.hasControl(['/customers/banBatchVue'])"
          type="primary"
          size="mini"
          @click="batchBan"
          >激活/禁用客户</el-button
        >
        <el-button-group class="m-l-10">
          <el-button
            v-for="(item, index) in typeList"
            :key="index"
            :type="routerType === item.val ? 'primary' : 'default'"
            size="mini"
            @click="toggleType(item.val)"
          >
            <span>{{ item.key }}</span>
            <span v-if="item.key !== '全部'">({{ item.count }})</span>
          </el-button>
        </el-button-group>
      </template>
      <template #tools>
        <el-button
          size="mini"
          title="模板下载"
          class="el-icon-notebook-2"
          circle
          plain
          @click="downloadModule"
        />
      </template>
    </vxe-toolbar>

    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      :loading="loading"
      :height="this.$util.getViewHeight() - 148"
      :print-config="{}"
      :import-config="{
        remote: true,
        importMethod: this.importMethod,
        modes: ['insert'],
        type: ['xlsx'],
        types: ['xlsx']
      }"
      :scroll-y="{ enabled: false }"
      :data="tableDataMain"
      :columns="tableColumn"
      :mouse-config="{ selected: false }"
    >
      <!-- slot_header -->
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          :value.sync="filterData[column.field]"
          @change="headerFilterChange"
        />
      </template>
      <template #header_daterange="{ column }">
        <c-table-header
          type="daterange"
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          :value.sync="filterData.create_date"
          @change="headerFilterChange"
        />
      </template>

      <!-- slot_default -->
      <template #default_photo_list="{ row }">
        <e-upload-image v-if="row.photo_list" :list.sync="row.photo_list" disabled />
      </template>
      <template #default_customer_name="{ row }">
        <el-link type="primary" @click="remarkFollowUp(row.id)">{{ row.customer_name }}</el-link>
      </template>
      <template #default_gen_zong_count="{ row }">
        <div class="f-bold">{{ row.gen_zong_count || 0 }}次</div>
        <div class="c-green">(距上次跟进{{ row.gen_jin_date_tian_shu || 0 }}天)</div>
      </template>

      <template #default_jie_dai_zhuang_tai="{ row }">
        <el-link
          :type="row.jie_dai_zhuang_tai === '已接待' ? 'success' : 'danger'"
          size="mini"
          @click="toggleJieDai(row)"
        >
          {{ row.jie_dai_zhuang_tai || '待接待' }}
        </el-link>
      </template>
      <template #default_state="{ row }">
        <el-tag :type="row.state === '激活' ? 'success' : 'danger'" size="mini">
          {{ row.state }}
        </el-tag>
      </template>
      <template #default_operate1="{ row }">
        <el-button
          v-if="$tool.hasControl(['/keHuGenZong/saveOrUpdate'])"
          type="success"
          size="mini"
          @click="remarkAdd(row)"
          >写跟进</el-button
        >
      </template>
      <template #default_operate2="{ row }">
        <el-button
          v-if="$tool.hasControl(['/customers/saveOrUpdate'])"
          type="primary"
          size="mini"
          @click="itemEdit(row.id)"
          >编辑</el-button
        >
        <el-button
          v-if="$tool.hasControl(['/customers/changeInfo'])"
          type="success"
          size="mini"
          @click="itemLog(row)"
        >
          更新记录
        </el-button>
        <el-button
          v-if="$tool.hasControl(['/customers/deleteVue'])"
          type="danger"
          size="mini"
          @click="itemDelete(row)"
          >删除</el-button
        >
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-增改客户 -->
    <b-popup-customer
      v-if="isShowPopupCustomer"
      :show.sync="isShowPopupCustomer"
      :id="activeId"
      @success="getListData"
    />

    <!-- 弹窗-导入 -->
    <PopupImport
      v-if="isShowPopupImport"
      :show.sync="isShowPopupImport"
      :isError="isError"
      :uuid="uuid"
      :list="importTableData"
      @success="getListData"
    />

    <!-- 弹窗-批量替换 -->
    <PopupBatchReplace
      v-if="isShowPopupBatchReplace"
      :show.sync="isShowPopupBatchReplace"
      :list="checkboxListData"
      @success="getListData"
    />

    <!-- 弹窗-写跟进 -->
    <PopupRemarkAdd
      v-if="isShowPopupRemarkAdd"
      :show.sync="isShowPopupRemarkAdd"
      :detail="activeDetail"
      @success="getListData"
    />

    <!-- 弹窗-跟进记录 -->
    <b-popup-customer-follow-up
      v-if="isShowPopupCustomerFollowUp"
      :show.sync="isShowPopupCustomerFollowUp"
      :id="activeId"
    />

    <!-- 弹窗-客户修改日志 -->
    <PopupUpdateLog
      v-if="isShowPopupUpdateLog"
      :show.sync="isShowPopupUpdateLog"
      :detail="activeDetail"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupImport: () => import('./popup-import'),
    PopupBatchReplace: () => import('./popup-batch-replace'),
    PopupRemarkAdd: () => import('./popup-remark-add'),
    PopupUpdateLog: () => import('./popup-update-log')
  },
  data() {
    return {
      loading: true,

      remvoeIds: [],
      banIds: [],
      routerType: '',
      routerStatus: '',

      filterData: {
        create_date: [this.$util.getDate().yearDay, this.$util.getDate().today],
        jie_dai_zhuang_tai: ''
      },
      sortData: { id: 'desc' },
      headerFilterUrl: '/admin/customers/searchHeard',
      tableColumn: [
        {
          type: 'checkbox',
          width: 40
        },
        {
          field: 'id',
          width: 70,
          title: '客户编号',
          slots: { header: 'header_input' }
        },
        {
          field: 'create_date',
          width: 180,
          title: '创建日期',
          slots: { header: 'header_daterange' }
        },
        {
          field: 'sales_man',
          title: '业务员',
          width: 100,
          slots: { header: 'header_input' }
        },
        {
          title: '附件图片',
          width: 63,
          slots: { default: 'default_photo_list' }
        },
        {
          field: 'customer_name',
          title: '客户企业名称',
          slots: { header: 'header_input', default: 'default_customer_name' }
        },
        {
          field: 'customer_rating',
          title: '客户评级',
          slots: { header: 'header_input' }
        },
        {
          field: 'linkman',
          title: '联系人',
          width: 80,
          slots: { header: 'header_input' }
        },
        {
          field: 'phone',
          title: '联系电话',
          width: 90,
          slots: { header: 'header_input' }
        },
        {
          field: 'gen_zong_count',
          title: '跟进次数',
          slots: { header: 'header_input', default: 'default_gen_zong_count' }
        },
        {
          field: 'wei_xin',
          title: '联系人微信',
          slots: { header: 'header_input' }
        },
        {
          field: 'address',
          title: '客户地址',
          slots: { header: 'header_input' }
        },
        {
          field: 'alibaba',
          title: '旺旺号',
          width: 80,
          slots: { header: 'header_input' }
        },
        {
          field: 'lai_yuan',
          title: '客户来源',
          width: 80,
          slots: { header: 'header_input' }
        },
        {
          field: 'jie_dai_zhuang_tai',
          title: '接待状态',
          width: 80,
          slots: { header: 'header_input', default: 'default_jie_dai_zhuang_tai' }
        },
        {
          field: 'state',
          title: '使用状态',
          width: 80,
          slots: { header: 'header_input', default: 'default_state' }
        },
        {
          title: '跟进操作',
          width: 80,
          slots: { default: 'default_operate1' }
        },
        {
          title: '客户操作',
          width: 180,
          slots: { default: 'default_operate2' }
        }
      ],
      tableDataMain: [],
      pageOptions: {
        ...this.$constant.page
      },
      totalObj: {
        yi_cheng_jiao_count: '',
        wei_cheng_jiao_count: '',
        shi_tian_wei_gen_jin_count: '',
        er_shi_tian_wei_gen_jin_count: '',
        san_shi_tian_wei_gen_jin_count: ''
      },

      isShowPopupImport: false,
      isShowPopupBatchReplace: false,
      isShowPopupCustomer: false,
      isShowPopupRemarkAdd: false,
      isShowPopupCustomerFollowUp: false,
      isShowPopupUpdateLog: false,
      isError: '',
      activeDetail: null,
      activeId: null,
      uuid: '',
      importTableData: [],

      checkboxListData: []
    }
  },
  computed: {
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    },
    typeList() {
      let result = [
        {
          key: '全部',
          val: '',
          count: ''
        },
        {
          key: '已成交客户',
          val: '已成交客户',
          count: this.totalObj.yi_cheng_jiao_count
        },
        {
          key: '未成交客户',
          val: '未成交客户',
          count: this.totalObj.wei_cheng_jiao_count
        },
        {
          key: '10天没跟进客户',
          val: '10天没跟进客户',
          count: this.totalObj.shi_tian_wei_gen_jin_count
        },
        {
          key: '20天没跟进客户',
          val: '20天没跟进客户',
          count: this.totalObj.er_shi_tian_wei_gen_jin_count
        },
        {
          key: '30天没跟进客户',
          val: '30天没跟进客户',
          count: this.totalObj.san_shi_tian_wei_gen_jin_count
        }
      ]
      return result
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.refTable.connect(this.$refs.refToolbar)
      this.routerType = this.$route.query.type || ''
      this.routerStatus = this.$route.query.status || ''
      if (this.routerStatus) this.filterData.jie_dai_zhuang_tai = this.routerStatus

      this.getListData()
    })
  },
  methods: {
    // 切换类型
    toggleType(val) {
      this.routerType = val
      this.searchListData()
    },
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索数据列表
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取数据列表
    getListData() {
      this.loading = true
      let params = {
        currentPage: this.pageOptions.currentPage,
        pageSize: this.pageOptions.pageSize,
        sortData: this.$util.deepCopy(this.sortData),
        filterData: this.$util.deepCopy(this.filterData)
      }
      if (this.routerType) params.searchType = this.routerType
      this.$api({
        method: 'post',
        url: '/admin/customers/search',
        data: params
      })
        .then((res) => {
          if (res.status === 200) {
            this.tableDataMain = res.data.page.list
            this.pageOptions.pageSize = res.data.page.pageSize
            this.pageOptions.total = res.data.page.totalRow
            this.pageOptions.currentPage = res.data.page.pageNumber

            this.totalObj.yi_cheng_jiao_count = res.data.yi_cheng_jiao_count || 0
            this.totalObj.wei_cheng_jiao_count = res.data.wei_cheng_jiao_count || 0
            this.totalObj.shi_tian_wei_gen_jin_count = res.data.shi_tian_wei_gen_jin_count || 0
            this.totalObj.er_shi_tian_wei_gen_jin_count =
              res.data.er_shi_tian_wei_gen_jin_count || 0
            this.totalObj.san_shi_tian_wei_gen_jin_count =
              res.data.san_shi_tian_wei_gen_jin_count || 0
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    itemAdd() {
      this.activeId = null
      this.isShowPopupCustomer = true
    },
    itemEdit(id) {
      this.activeId = id
      this.isShowPopupCustomer = true
    },
    itemLog(data) {
      this.activeDetail = data
      this.isShowPopupUpdateLog = true
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm('您确认要删除该数据?', '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/customers/deleteVue',
            params: {
              id: row.id
            }
          }).then((res) => {
            if (res.status === 200 && res.data.state === 'ok') {
              this.$message.success('删除成功')
              this.getListData()
            }
          })
        })
        .catch(() => {})
    },
    // 批量-激活/禁用
    batchBan() {
      const $grid = this.$refs.refTable
      const selectRecords = $grid.getCheckboxRecords()
      this.banIds = []
      for (let i = 0; i < selectRecords.length; i++) {
        this.banIds.push(selectRecords[i].id)
      }
      if (selectRecords.length > 0) {
        this.$confirm(`您确认要激活/禁用${this.banIds.length}个客户?`, '提示')
          .then(() => {
            this.$api({
              method: 'get',
              url: '/admin/customers/banBatchVue',
              params: {
                banIds: this.banIds
              }
            }).then((res) => {
              if (res.status === 200 && res.data.state === 'ok') {
                this.$message.success('批量删除成功')
                this.getListData()
              }
            })
          })
          .catch(() => {})
      } else {
        this.$message.error('请先选择')
      }
    },
    // 批量-删除
    batchDelete() {
      const $grid = this.$refs.refTable
      const selectRecords = $grid.getCheckboxRecords()
      this.remvoeIds = []
      for (let i = 0; i < selectRecords.length; i++) {
        this.remvoeIds.push(selectRecords[i].id)
      }
      if (selectRecords.length > 0) {
        this.$confirm(`您确认要删除${this.remvoeIds.length}条数据?`, '提示')
          .then(() => {
            this.$api({
              method: 'get',
              url: '/admin/customers/deleteBatchVue',
              params: {
                remvoeIds: this.remvoeIds
              }
            }).then((res) => {
              if (res.status === 200 && res.data.state === 'ok') {
                this.$message.success('批量删除成功')
                this.getListData()
              }
            })
          })
          .catch(() => {})
      } else {
        this.$message.error('请先选择')
      }
    },
    // 批量-替换业务员
    batchReplaceSalesMan() {
      const $grid = this.$refs.refTable
      const selectRecords = $grid.getCheckboxRecords()
      if (selectRecords.length > 0) {
        this.checkboxListData = selectRecords
        this.isShowPopupBatchReplace = true
      } else {
        this.$message.error('请先选择')
      }
    },
    // 模板下载
    downloadModule() {
      window.open('/template/Customers.xlsx', '_blank')
    },
    // 导入方法
    importMethod({ file }) {
      const formBody = new FormData()
      formBody.append('file', file)
      this.$api({
        method: 'post',
        url: '/admin/customers/importExcel',
        data: formBody
      })
        .then((res) => {
          if (res.status === 200 && res.data.state === 'ok') {
            this.isError = res.data.isError
            if (res.data.isError == true) {
              this.importTableData = res.data.customerListError
            } else {
              this.importTableData = res.data.customerList
            }

            this.uuid = res.data.uuid
            this.isShowPopupImport = true
          }
        })
        .catch(() => {})
    },
    // 记录-新增
    remarkAdd(data) {
      this.activeDetail = data
      this.isShowPopupRemarkAdd = true
    },
    // 记录-详情
    remarkFollowUp(id) {
      this.activeId = id
      this.isShowPopupCustomerFollowUp = true
    },
    toggleJieDai(data) {
      this.$api({
        method: 'post',
        url: '/admin/customers/zhuangTai',
        data: {
          id: data.id,
          jie_dai_zhuang_tai: data.jie_dai_zhuang_tai === '已接待' ? '待接待' : '已接待'
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.getListData()
          this.$message.success('修改成功')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
